import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const printersAdapter = getAdapter({ idFieldName: 'installName' });

const printersSlice = createSlice({
  name: 'printers',
  initialState: printersAdapter.getInitialState(),
  reducers: {
    setPrinters: (state, { payload: { printers } }) => {
      printersAdapter.setAll(state, printers);
    },
  },
});

const selectors = printersAdapter.getSelectors(({ printers }) => printers);

export const getPrinters = (state) => selectors.selectAll(state);

export const {
  setPrinters,
} = printersSlice.actions;

export default printersSlice.reducer;
